
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/api/circular-progress",
      function () {
        return require("private-next-pages/material-ui/api/circular-progress.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/api/circular-progress"])
      });
    }
  